<div #stickyMenu [class.sticky]="sticky">
  <div class="my-cart-container">
    <div class="" aria-label="Order Summary">
      <form [formGroup]="form">
        <div class="row">
          <div class="col s12">
            <label name="returnRequestId">Request ID : {{ returnRequestId.value }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <mat-label>Comments:</mat-label>
            <mat-form-field>
              <textarea name="comments" [formControl]="comments" style="resize: none;" maxlength="160"></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
      <div class="btn-group mt-10 mb-10">
        <button
          class="btn btn-primary"
          data-event-cate="Cart"
          type="button"
          [disabled]="isLoading || form.invalid"
          (click)="onSubmit()"
        >
          Submit Return Request
          <fa-icon *ngIf="isLoading" icon="spinner" [spin]="true"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</div>
